import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/leads");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-baseline gap-2 mb-12 justify-center">
          <span className="font-serif text-2xl text-white">Elite Development Consultants</span>
          <span className="overline text-[#d4af37]">USA LLC</span>
        </Link>

        <div className="border border-white/10 bg-[#0a0a0a] rounded-sm p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={18} className="text-[#d4af37]" />
            <h1 className="font-serif text-2xl text-white">Admin Access</h1>
          </div>

          <form onSubmit={submit} className="space-y-7" data-testid="admin-login-form">
            <label className="block">
              <span className="overline text-white/40 block mb-3">Email</span>
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-white/20 py-3 text-white font-light focus:border-[#d4af37] outline-none transition-colors"
                placeholder="you@elitedevelopmentconsulting.com"
              />
            </label>
            <label className="block">
              <span className="overline text-white/40 block mb-3">Password</span>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-white/20 py-3 text-white font-light focus:border-[#d4af37] outline-none transition-colors"
                placeholder="••••••••"
              />
            </label>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="btn-gold rounded-full w-full py-4 text-xs font-semibold tracking-wider uppercase inline-flex items-center justify-center gap-3 disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
              <ArrowRight size={16} />
            </button>
          </form>
        </div>

        <Link to="/" className="block text-center mt-8 text-white/40 text-sm hover:text-[#d4af37] transition-colors">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
